import { Tag } from "@chakra-ui/react";
import colors from "core/resources/theme/colors";

function IconWrapper({
  onClick,
  selected,
  children,
}: {
  onClick: () => any;
  selected: boolean;
  children: React.ReactNode;
}) {
  return (
    <Tag
      variant={selected ? "solid" : "outline"}
      colorScheme="blue"
      borderRadius="full"
      mr="6px"
      mb="8px"
      py={2}
      _hover={{
        border: `2px solid ${colors.primary}`,
      }}
      border="2px solid transparent"
      transition="all 0.3s"
      onClick={onClick}
      cursor="pointer"
    >
      {children}
    </Tag>
  );
}

export default IconWrapper;
